import React, { Component, StatelessComponent } from 'react';
import { Link, Route } from 'react-router-dom';
import Helmet from 'react-helmet';
import b from 'b_';
import pageMeta from './not-found.meta';

// Компонент для передачи статуса при серверном рендеринге
// Например, если страница не найдена, отдаем клиенту 404 ошибку
const Status: StatelessComponent<any> = ({ code, children }) => {
    const render = ({ staticContext }: any) => {
        if (staticContext) {
            staticContext.status = code;
        }

        return children;
    };

    return (
        <Route render={render} />
    );
};

const class_ = b.with('page');

export default class NotFoundPage extends Component {
    render() {
        return (
            <Status code={404}>
                <Helmet>
                    <title>{pageMeta.title}</title>
                    <meta name="description" content={pageMeta.description} />
                    <meta name="keywords" content={pageMeta.keywords} />
                </Helmet>
                <div className={class_({ type: 'not-found' })}>
                    <h1>Нет такой страницы</h1>
                    Вы можете перейти <Link to="/">на главную</Link>
                </div>
            </Status>
        );
    }
}
